import { SVGProps } from 'react'

const Logo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={146}
    height={81}
    fill='none'
    {...props}
  >
    <path
      fill='#fff'
      d='M61.047 34.621c-.946 0-1.885-.247-2.811-.744v4.215c0 .827-.146 1.404-.438 1.734-.291.33-.792.497-1.502.497h-1.391l-.166-.19V20.74l.166-.191h1.009c.966 0 1.64.45 2.018 1.348 1.037-1.046 2.295-1.57 3.77-1.57 1.473 0 2.648.635 3.468 1.912.82 1.276 1.23 3.026 1.23 5.244 0 1.102-.142 2.092-.422 2.975-.283.883-.666 1.63-1.147 2.242a5.086 5.086 0 0 1-1.691 1.42 4.536 4.536 0 0 1-2.09.497l-.003.004Zm-.328-11.372c-.981 0-1.809.477-2.483 1.431v6.39c.8.533 1.53.8 2.184.8.765 0 1.348-.39 1.746-1.17.398-.779.6-1.877.6-3.292 0-1.416-.19-2.481-.572-3.153-.383-.672-.875-1.006-1.475-1.006ZM80.674 21.042l-3.496 12.943c-.6 2.183-1.36 3.801-2.279 4.847-.918 1.046-2.298 1.57-4.135 1.57a8.663 8.663 0 0 1-2.976-.524c-.036-.406.015-.863.165-1.376.146-.513.335-.91.572-1.185.8.258 1.557.386 2.266.386 1.4 0 2.386-.935 2.95-2.808l.11-.357c-.69-.02-1.238-.148-1.64-.386-.402-.239-.682-.644-.848-1.213l-3.386-11.953c.741-.35 1.4-.525 1.979-.525.58 0 1.005.116 1.285.346.28.231.505.637.666 1.225l1.565 5.81c.11.421.375 1.697.797 3.829.015.127.098.19.248.19l2.688-11.153c.418-.111.947-.167 1.585-.167.639 0 1.218.091 1.746.274l.138.219v.008ZM82.26 22.366c.07-.33.22-.68.449-1.046.228-.366.461-.644.697-.827 1.475.183 2.484 1.01 3.032 2.477.69-1.634 1.845-2.449 3.465-2.449.6 0 1.147.064 1.64.19 0 1.285-.292 2.407-.875 3.36-.272-.09-.69-.154-1.258-.19-1.056 0-1.911.569-2.566 1.706v8.784a10.64 10.64 0 0 1-1.762.139c-.63 0-1.234-.048-1.817-.14v-9.169c0-1.304-.335-2.25-1.01-2.835h.004ZM100.086 34.621c-.946 0-1.885-.247-2.811-.744v4.215c0 .827-.146 1.404-.438 1.734-.291.33-.792.497-1.502.497h-1.391l-.166-.19V20.74l.166-.191h1.009c.966 0 1.64.45 2.018 1.348 1.037-1.046 2.295-1.57 3.769-1.57 1.474 0 2.649.635 3.469 1.912.82 1.276 1.23 3.026 1.23 5.244 0 1.102-.142 2.092-.422 2.975-.284.883-.666 1.63-1.147 2.242a5.082 5.082 0 0 1-1.691 1.42 4.536 4.536 0 0 1-2.089.497l-.004.004Zm-.328-11.372c-.981 0-1.809.477-2.483 1.431v6.39c.8.533 1.53.8 2.184.8.765 0 1.348-.39 1.746-1.17.398-.779.599-1.877.599-3.292 0-1.416-.189-2.481-.571-3.153-.383-.672-.875-1.006-1.475-1.006ZM118.022 21.87c1.294 1.303 1.94 3.192 1.94 5.673 0 1.102-.138 2.1-.41 2.987-.272.89-.67 1.646-1.187 2.27a5.256 5.256 0 0 1-1.923 1.447c-.765.338-1.628.51-2.594.51s-1.825-.172-2.578-.51a5.232 5.232 0 0 1-1.912-1.447c-.521-.624-.915-1.38-1.187-2.27-.272-.891-.41-1.885-.41-2.987 0-2.222.528-3.98 1.585-5.272 1.056-1.293 2.558-1.94 4.506-1.94 1.711 0 3.102.512 4.178 1.542l-.008-.004Zm-4.178 1.156c-1.601 0-2.401 1.507-2.401 4.517 0 3.01.8 4.49 2.401 4.49 1.6 0 2.428-1.495 2.428-4.49 0-2.994-.808-4.517-2.428-4.517ZM121.925 33.409c.016-.406.13-.847.343-1.337.209-.485.449-.866.725-1.14 1.439.79 2.705 1.184 3.797 1.184.599 0 1.088-.119 1.462-.358.375-.238.56-.56.56-.962 0-.644-.493-1.157-1.475-1.543l-1.529-.576c-2.294-.843-3.442-2.195-3.442-4.048 0-.66.123-1.253.367-1.777a3.87 3.87 0 0 1 1.037-1.349 4.685 4.685 0 0 1 1.596-.866c.619-.203 1.309-.303 2.074-.303.347 0 .733.028 1.159.084.426.056.859.135 1.297.235.438.099.855.214 1.257.346.399.127.746.266 1.037.413 0 .457-.09.934-.272 1.431-.181.498-.429.863-.737 1.102-1.439-.644-2.685-.962-3.741-.962-.473 0-.848.115-1.12.346a1.12 1.12 0 0 0-.41.894c0 .569.454 1.018 1.364 1.348l1.664.605c1.202.421 2.093 1.002 2.677 1.733.583.736.875 1.587.875 2.561 0 1.304-.481 2.346-1.447 3.126-.966.779-2.349 1.169-4.151 1.169-1.802 0-3.422-.45-4.967-1.349v-.007ZM145.704 28.7h-7.533c.055 1.01.288 1.806.698 2.382.409.577 1.123.867 2.144.867 1.021 0 2.267-.31 3.631-.934.528.548.863 1.276 1.009 2.175-1.455 1.045-3.205 1.57-5.243 1.57-1.928 0-3.39-.6-4.384-1.805-.993-1.2-1.486-2.986-1.486-5.356 0-1.102.126-2.096.382-2.986.257-.891.627-1.65 1.12-2.287a5.147 5.147 0 0 1 1.802-1.475c.709-.35 1.517-.525 2.428-.525s1.746.143 2.456.426a4.983 4.983 0 0 1 1.801 1.212c.493.525.86 1.142 1.104 1.857.245.716.367 1.495.367 2.342 0 .458-.028.895-.083 1.309-.055.413-.126.823-.217 1.224l.004.004Zm-5.27-5.781c-1.42 0-2.184 1.081-2.295 3.248h4.534v-.33c0-.882-.182-1.586-.544-2.119-.363-.533-.927-.8-1.692-.8h-.003Z'
    />
    <g filter='url(#a)'>
      <path
        fill='url(#b)'
        d='M35.927 13.765c-6.761 4.333-10.853 11.85-10.853 19.932V49l2.652-1.867c5.087-3.582 7.997-9.868 7.997-13.646l-.373-.32c-2.02-1.735-1.783-4.949.47-6.364 5.664-3.632 9.096-9.931 9.096-16.7V8l-8.99 5.765Z'
      />
      <path
        fill='url(#c)'
        d='M35.524 35.449c.127-.543.199-1.962.199-1.962 0-8.081-3.973-15.389-10.734-19.726L16 8v2.12c0 6.76 3.427 13.05 9.082 16.675l8.629 5.308s2.08 1.243 1.813 3.341v.005Z'
      />
    </g>
    <defs>
      <linearGradient
        id='b'
        x1={48.012}
        x2={18.371}
        y1={10.62}
        y2={43.782}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#81E0B2' />
        <stop offset={0.338} stopColor='#8EE896' />
        <stop offset={0.505} stopColor='#5EC968' />
        <stop offset={0.58} stopColor='#4DAC56' />
        <stop offset={0.733} stopColor='#7CE186' />
        <stop offset={1} stopColor='#99EBA1' />
      </linearGradient>
      <linearGradient
        id='c'
        x1={21.702}
        x2={30.96}
        y1={25.637}
        y2={18.809}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#67D79A' />
        <stop offset={0.38} stopColor='#60D26C' />
        <stop offset={0.922} stopColor='#89E5A0' />
      </linearGradient>
      <filter
        id='a'
        width={68.915}
        height={81}
        x={-4}
        y={0}
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy={12} />
        <feGaussianBlur stdDeviation={10} />
        <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
        <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_468_428' />
        <feBlend
          in='SourceGraphic'
          in2='effect1_dropShadow_468_428'
          result='shape'
        />
      </filter>
    </defs>
  </svg>
)
export default Logo

